export default class StorageKeys
{}

StorageKeys.Favourites = 'Favourites';
